export default "__VITE_ASSET__kw$NXNdh__"